/**
 * Returns the Honduras states list to populate the select item.
 */
export function gluky_addressfield_hn_states_list() {
  let temporalStates = [];
  const states = {
    '10': 'Islas de la Bahía',
    '15': 'Cortés',
    '20': 'Atlántida',
    '25': 'Colón',
    '30': 'Gracias a Dios',
    '35': 'Copán',
    '40': 'Santa Bárbara',
    '45': 'Yoro',
    '50': 'Olancho',
    '55': 'Ocotepeque',
    '60': 'Lempira',
    '65': 'Intibucá',
    '70': 'Comayagua',
    '75': 'Francisco Morazán',
    '80': 'El Paraíso',
    '85': 'La Paz',
    '90': 'Valle',
    '95': 'Choluteca',
  };
  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Honduras cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The state code
 * @return
 */
export function gluky_addressfield_hn_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '10': {
      '10100': 'Roatán',
      '10101': 'Guanaja',
      '10102': 'José Santos Guardiola',
      '10103': 'Utila',
    },
    '15': {
      '15104': 'San Pedro Sula',
      '15105': 'Choloma',
      '15106': 'Omoa',
      '15107': 'Pimienta',
      '15108': 'Potrerillos',
      '15109': 'Puerto Cortés',
      '15110': 'San Antonio de Cortés',
      '15111': 'San Francisco de Yojoa',
      '15112': 'San Manuel',
      '15113': 'Santa Cruz de Yojoa',
      '15114': 'Villanueva',
      '15115': 'La Lima',
    },
    '20': {
      '20116': 'La Ceiba',
      '20117': 'Tela',
      '20118': 'Jutiapa',
      '20119': 'La Masica',
      '20120': 'San Francisco',
      '20121': 'Arizona',
      '20122': 'Esparta',
      '20123': 'El Porvenir',
    },
    '25': {
      '25124': 'Trujillo',
      '25125': 'Balfate',
      '25126': 'Iriona',
      '25127': 'Limón',
      '25128': 'Sabá',
      '25129': 'Santa Fe',
      '25130': 'Santa Rosa de Aguán',
      '25131': 'Sonaguera',
      '25132': 'Tocoa',
      '25133': 'Bonito Oriental',
    },
    '30': {
      '30134': 'Puerto Lempira',
      '30135': 'Brus Laguna',
      '30136': 'Ahuas',
      '30137': 'Juan Francisco Bulnes',
      '30138': 'Ramón Villeda Morales',
      '30139': 'Wampusirpe',
    },
    '35': {
      '35140': 'Santa Rosa de Copán',
      '35141': 'Cabañas',
      '35142': 'Concepción',
      '35143': 'Copán Ruinas',
      '35144': 'Corquín',
      '35145': 'Cucuyagua',
      '35146': 'Dolores',
      '35147': 'Dulce Nombre',
      '35148': 'El Paraíso',
      '35149': 'Florida',
      '35150': 'La Jigua',
      '35151': 'La Unión',
      '35152': 'Nueva Arcadia',
      '35153': 'San Agustín',
      '35154': 'San Antonio',
      '35155': 'San Jerónimo',
      '35156': 'San José',
      '35157': 'San Juan de Opoa',
      '35158': 'San Nicolás',
      '35159': 'San Pedro',
      '35160': 'Santa Rita',
      '35161': 'Trinidad de Copán',
      '35162': 'Veracruz',
    },
    '40': {
      '40163': 'Santa Bárbara',
      '40164': 'Arada',
      '40165': 'Atima',
      '40166': 'Azacualpa',
      '40167': 'Ceguaca',
      '40168': 'Concepción del Norte',
      '40169': 'Concepción del Sur',
      '40170': 'Chinda',
      '40171': 'El Níspero',
      '40172': 'Gualala',
      '40173': 'Ilama',
      '40174': 'Las Vegas',
      '40175': 'Macuelizo',
      '40176': 'Naranjito',
      '40177': 'Nuevo Celilac',
      '40178': 'Nueva Frontera',
      '40179': 'Petoa',
      '40180': 'Protección',
      '40181': 'Quimistán',
      '40182': 'San Francisco de Ojuera',
      '40183': 'San José de las Colinas',
      '40184': 'San Luis',
      '40185': 'San Marcos',
      '40186': 'San Nicolás',
      '40187': 'San Pedro Zacapa',
      '40188': 'San Vicente Centenario',
      '40189': 'Santa Rita',
      '40190': 'Trinidad',
    },
    '45': {
      '45191': 'Yoro',
      '45192': 'Arenal',
      '45193': 'El Negrito',
      '45194': 'El Progreso',
      '45195': 'Jocón',
      '45196': 'Morazán',
      '45197': 'Olanchito',
      '45198': 'Santa Rita',
      '45199': 'Sulaco',
      '45200': 'Victoria',
      '45201': 'Yorito',
    },
    '50': {
      '50202': 'Juticalpa',
      '50203': 'Campamento',
      '50204': 'Catacamas',
      '50205': 'Concordia',
      '50206': 'Dulce Nombre de Culmí',
      '50207': 'El Rosario',
      '50208': 'Esquipulas del Norte',
      '50209': 'Gualaco',
      '50210': 'Guarizama',
      '50211': 'Guata',
      '50212': 'Guayape',
      '50213': 'Jano',
      '50214': 'La Unión',
      '50215': 'Mangulile',
      '50216': 'Manto',
      '50217': 'Salamá',
      '50218': 'San Esteban',
      '50219': 'San Francisco de Becerra',
      '50220': 'San Francisco de la Paz',
      '50221': 'Santa María del Real',
      '50222': 'Silca',
      '50223': 'Yocón',
      '50224': 'Patuca',
    },
    '55': {
      '55225': 'Ocotepeque',
      '55226': 'Belén Gualcho',
      '55227': 'Concepción',
      '55228': 'Dolores Merendón',
      '55229': 'Fraternidad',
      '55230': 'La Encarnación',
      '55231': 'La Labor',
      '55232': 'Lucerna',
      '55233': 'Mercedes',
      '55234': 'San Fernando',
      '55235': 'San Francisco del Valle',
      '55236': 'San Jorge',
      '55237': 'San Marcos',
      '55238': 'Santa Fe',
      '55239': 'Sensenti',
      '55240': 'Sinuapa',
    },
    '60': {
      '60241': 'Gracias',
      '60242': 'Belén',
      '60243': 'Candelaria',
      '60244': 'Cololaca',
      '60245': 'Erandique',
      '60246': 'Gualcince',
      '60247': 'Guarita',
      '60248': 'La Campa',
      '60249': 'La Iguala',
      '60250': 'Las Flores',
      '60251': 'La Unión',
      '60252': 'La Virtud',
      '60253': 'Lepaera',
      '60254': 'Mapulaca',
      '60255': 'Piraera',
      '60256': 'San Andrés',
      '60257': 'San Francisco',
      '60258': 'San Juan Guarita',
      '60259': 'San Manuel Colohete',
      '60260': 'San Rafael',
      '60261': 'San Sebastián',
      '60262': 'Santa Cruz',
      '60263': 'Talgua',
      '60264': 'Tambla',
      '60265': 'Tomalá',
      '60266': 'Valladolid',
      '60267': 'Virginia',
      '60268': 'San Marcos de Caiquín',
    },
    '65': {
      '65269': 'La Esperanza',
      '65270': 'Camasca',
      '65271': 'Colomoncagua',
      '65272': 'Concepción',
      '65273': 'Dolores',
      '65274': 'Intibucá',
      '65275': 'Jesús de Otoro',
      '65276': 'Magdalena',
      '65277': 'Masaguara',
      '65278': 'San Antonio',
      '65279': 'San Isidro',
      '65280': 'San Juan',
      '65281': 'San Marcos de la Sierra',
      '65282': 'San Miguel Guancapla',
      '65283': 'Santa Lucía',
      '65284': 'Yamaranguila',
      '65285': 'San Francisco de Opalaca',
    },
    '70': {
      '70286': 'Comayagua',
      '70287': 'Ajuterique',
      '70288': 'El Rosario',
      '70289': 'Esquías',
      '70290': 'Humuya',
      '70291': 'La libertad',
      '70292': 'Lamaní',
      '70293': 'La Trinidad',
      '70294': 'Lejamani',
      '70295': 'Meambar',
      '70296': 'Minas de Oro',
      '70297': 'Ojos de Agua',
      '70298': 'San Jerónimo (Honduras)',
      '70299': 'San José de Comayagua',
      '70300': 'San José del Potrero',
      '70301': 'San Luis',
      '70302': 'San Sebastián',
      '70303': 'Siguatepeque',
      '70304': 'Villa de San Antonio',
      '70305': 'Las Lajas',
      '70306': 'Taulabé',
    },
    '75': {
      '75307': 'Distrito Central',
      '75308': 'Alubarén',
      '75309': 'Cedros',
      '75310': 'Curarén',
      '75311': 'El Porvenir',
      '75312': 'Guaimaca',
      '75313': 'La Libertad',
      '75314': 'La Venta',
      '75315': 'Lepaterique',
      '75316': 'Maraita',
      '75317': 'Marale',
      '75318': 'Nueva Armenia',
      '75319': 'Ojojona',
      '75320': 'Orica',
      '75321': 'Reitoca',
      '75322': 'Sabanagrande',
      '75323': 'San Antonio de Oriente',
      '75324': 'San Buenaventura',
      '75325': 'San Ignacio',
      '75326': 'San Juan de Flores',
      '75327': 'San Miguelito',
      '75328': 'Santa Ana',
      '75329': 'Santa Lucía',
      '75330': 'Talanga',
      '75331': 'Tatumbla',
      '75332': 'Valle de Ángeles',
      '75333': 'Villa de San Francisco',
      '75334': 'Vallecillo',
    },
    '80': {
      '80335': 'Yuscarán',
      '80336': 'Alauca',
      '80337': 'Danlí',
      '80338': 'El Paraíso',
      '80339': 'Güinope',
      '80340': 'Jacaleapa',
      '80341': 'Liure',
      '80342': 'Morocelí',
      '80343': 'Oropolí',
      '80344': 'Potrerillos',
      '80345': 'San Antonio de Flores',
      '80346': 'San Lucas',
      '80347': 'San Matías',
      '80348': 'Soledad',
      '80349': 'Teupasenti',
      '80350': 'Texiguat',
      '80351': 'Vado Ancho',
      '80352': 'Yauyupe',
      '80353': 'Trojes',
    },
    '85': {
      '85354': 'La Paz',
      '85355': 'Aguanqueterique',
      '85356': 'Cabañas',
      '85357': 'Cane',
      '85358': 'Chinacla',
      '85359': 'Guajiquiro',
      '85360': 'Lauterique',
      '85361': 'Marcala',
      '85362': 'Mercedes de Oriente',
      '85363': 'Opatoro',
      '85364': 'San Antonio del Norte',
      '85365': 'San José',
      '85366': 'San Juan',
      '85367': 'San Pedro de Tutule',
      '85368': 'Santa Ana',
      '85369': 'Santa Elena',
      '85370': 'Santa María',
      '85371': 'Santiago de Puringla',
      '85372': 'Yarula',
    },
    '90': {
      '90373': 'Nacaome',
      '90374': 'Alianza',
      '90375': 'Amapala',
      '90376': 'Aramecina',
      '90377': 'Caridad',
      '90378': 'Goascorán',
      '90379': 'Langue',
      '90380': 'San Francisco de Coray',
      '90381': 'San Lorenzo',
    },
    '95': {
      '95382': 'Choluteca',
      '95383': 'Apacilagua',
      '95384': 'Concepción de María',
      '95385': 'Duyure',
      '95386': 'El Corpus',
      '95387': 'El Triunfo',
      '95388': 'Marcovia',
      '95389': 'Morolica',
      '95390': 'Namasigue',
      '95391': 'Orocuina',
      '95392': 'Pespire',
      '95393': 'San Antonio de Flores',
      '95394': 'San Isidro',
      '95395': 'San José',
      '95396': 'San Marcos de Colón',
      '95397': 'Santa Ana de Yusguare',
    },
  };
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}
